import React, {useState, useEffect, useContext} from 'react';
import { 
  Container, 
  Grid, 
  makeStyles 
} from '@material-ui/core';
import Page from 'src/components/Page';
import {getMusic} from './helperFx';
import SongUploader from './SongUploader';
import MyMusic from './MyMusic';
import MusicianContext from 'src/musicianContext';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Music = () => {
  const classes = useStyles();
  const musician = useContext(MusicianContext);
  const [music, setMusic] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFirebaseMusic = async () => {
        const res = await getMusic(musician.musician);
        setMusic(res)
        setIsLoading(false);
    }
    if (!music.length) {
        fetchFirebaseMusic()
    }
  }, [musician, music]);

  const updateMusicView = async () => {
    const res = await getMusic(musician.musician);
    setMusic(res)
  };

  return (
    <Page className={classes.root} title="Account">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item lg={8} md={6} xs={12}>
            <MyMusic 
              music={music}
              isLoading={isLoading}
              updateMusicView={updateMusicView}
            />
          </Grid>
          <Grid item lg={4} md={6} xs={12}>
            <SongUploader 
              updateMusicView={updateMusicView}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Music;
